import authServices from "services/authSvc";
import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  SET_MESSAGE,
  CLEAR_MESSAGE,
} from "./authType";

const register = (data) => (dispatch) => {
  return authServices.register(data).then(
    (response) => {
      dispatch({ type: REGISTER_SUCCESS });

      dispatch({
        type: SET_MESSAGE,
        payload: { type: true, msg: response.data.description },
      });

      return Promise.resolve();
    },
    (error) => {
      const msgError = error?.response?.data?.data[0].msg || error.messages;

      dispatch({
        type: REGISTER_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: { type: false, msg: msgError },
      });

      return Promise.reject();
    }
  );
};
const registerV2 = (data) => (dispatch) => {
  return authServices.registerV2(data).then(
    (response) => {
      // console.log('response', response)
      dispatch({ type: REGISTER_SUCCESS });

      dispatch({
        type: SET_MESSAGE,
        payload: { type: true, msg: response.data.description },
      });

      return Promise.resolve();
    },
    (error) => {
      const msgError = error?.response?.data?.data[0].msg || error.messages;

      dispatch({
        type: REGISTER_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: { type: false, msg: msgError },
      });

      return Promise.reject();
    }
  );
};

const login = (email, password) => (dispatch) => {
  return authServices.login(email, password).then(
    (response) => {
      dispatch({
        type: LOGIN_SUCCESS,
        payload: { user: response.data.data },
      });

      dispatch({
        type: CLEAR_MESSAGE,
      });

      return Promise.resolve();
    },
    (error) => {
      const msgError = error?.response?.data?.data[0]?.msg || error.messages;

      dispatch({
        type: LOGIN_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: { type: false, msg: msgError },
      });

      return Promise.reject();
    }
  );
};

const logout = () => (dispatch) => {
  authServices.logout();

  dispatch({
    type: LOGOUT,
  });

  dispatch({
    type: CLEAR_MESSAGE,
  });
};

const clearMessage = () => (dispatch) => {
  dispatch({
    type: CLEAR_MESSAGE,
  });
};

export { login, register, registerV2, logout, clearMessage };
